import { render, staticRenderFns } from "./TimelineComponent.vue?vue&type=template&id=3b11f3f1"
import script from "./TimelineComponent.vue?vue&type=script&lang=js"
export * from "./TimelineComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports